import { ContactModel } from '@/models/contact.model'
import { api } from '@/services/api'

type FetchContactsByCompany = {
  companyId: string
  ownerId: string
}

export type FetchContactsByCompanyResponse = {
  contacts: ContactModel[]
}

export async function fetchContactsByCompany(params: FetchContactsByCompany) {
  const response = await api.get<FetchContactsByCompanyResponse>(`/contacts/find-many`, {
    params: { ...params, page: 1, perPage: 99999999 }
  })
  return response.data
}
